{
  "hero": {
    "loading": "Se încarcă conținutul...",
    "headline": {
      "line1": "Conținut strategic pentru afaceri.",
      "line2": "Eficiență și profesionalism în marketing digital"
    },
    "subheadline": "Tehnologie, design și videografie, integrate pentru a rezolva probleme reale de business",
    "primaryCta": "Vezi proiecte",
    "secondaryCta": "Programează o sesiune de strategie în Timișoara"
  },
  "hook": "Investiția în conținut video nu este un trend, ci o decizie strategică de creștere și de poziționare pe o piață competitivă.",
  "industry": {
    "title": "Soluții media pe industrii",
    "options": {
      "ecommerce": "Afaceri e-commerce",
      "restaurants": "Restaurante și cafenele",
      "retail": "Magazine retail",
      "salons": "Saloane și spa-uri",
      "fitness": "Centre fitness și săli de sport",
      "realestate": "Agenții imobiliare",
      "professional": "Servicii profesionale",
      "homeservices": "Servicii pentru casă"
    }
  },
  "problem": {
    "heading": "De ce majoritatea proiectelor digitale nu rezonează.",
    "copy": "Dezvoltarea, designul și videografia sunt adesea externalizate separat. Rezultatul: un brand fragmentat, fără o direcție comună. După două decenii de proiecte digitale, un pattern este constant — site-uri bine construite, dar cu un conținut gol. Khromatik a fost creat pentru a rezolva această problemă."
  },
  "pillars": {
    "architect": {
      "title": "Arhitectul",
      "subtitle": "Consultanță",
      "description": "Audituri UI/UX și arhitectură frontend pentru platforme complexe. Expertiză de nivel senior pentru provocări de anvergură."
    },
    "builder": {
      "title": "Constructorul",
      "subtitle": "Dezvoltare",
      "description": "Identități de brand și website-uri de înaltă performanță, construite pentru conversie."
    },
    "storyteller": {
      "title": "Povestitorul",
      "subtitle": "Conținut",
      "description": "Video și fotografie cinematice, filmate on-location în Timișoara, pentru a da tehnologiei o dimensiune umană."
    }
  },
  "holisticEdge": {
    "heading": "O viziune clară. Implementare fluidă.",
    "workflow": {
      "strategy": "Strategie",
      "design": "Design",
      "code": "Cod",
      "content": "Conținut",
      "launch": "Lansare"
    },
    "valueProposition": "Video și dezvoltare din aceeași viziune: website-ul este construit în jurul poveștii, nu invers."
  },
  "socialProof": {
    "heading": "Experiență de 20 de ani",
    "recommendations": {
      "heading": "Recomandări"
    },
    "featuredProject": {
      "title": "Proiect recomandat",
      "projectTitle": "Lansare parteneriat Polestar",
      "description": "Campanie completă: branding, website și video, dintr-o singură viziune.",
      "cta": "Vezi studiul de caz"
    }
  },
  "localPresence": {
    "heading": "Calitate de înaltă clasă, livrare locală",
    "copy": "Studio cu sediul în Timișoara: standarde de piață occidentală și colaborare locală, față în față. De la o zi de conținut la birou, în Arad, până la un workshop UI în Timișoara — departament creativ disponibil la cerere."
  },
  "packages": {
    "heading": "Modele de colaborare",
    "audit": {
      "title": "Auditul",
      "description": "Rezultat rapid pentru companii mari. Audit UI/UX și recomandări strategice.",
      "cta": "Detalii"
    },
    "launch": {
      "title": "Lansarea",
      "description": "Pentru branduri noi. Identitate digitală completă, de la concept la lansare.",
      "cta": "Detalii"
    },
    "partnership": {
      "title": "Parteneriatul",
      "description": "Retainer lunar de conținut. Suport continuu pentru afaceri în creștere.",
      "cta": "Detalii"
    }
  },
  "footerCta": {
    "heading": "Prezență digitală unitară, de la strategie la execuție.",
    "contactText": "Discuție despre proiect",
    "bookSession": "Programează o sesiune de strategie",
    "or": "sau",
    "contactLink": "Contact"
  }
}
